<template>
  <div id="investor">
    <big-title>
      Mis <span>movimientos</span>.
    </big-title>

    <vx-card title="¿Cuáles han sido tus últimas actividades en la Red?">
       <p>En este apartado podrás consultar todos los movimientos realizados en tu cuenta relacionados a tus inversiones, pagos, reembolsos y más. Para un compilado mensual de esta información podrás descargar tus estados de cuenta
         <span><router-link class="bold ml-1 inline-link-primary text-dark" to="" @click.native="goToStatementsPage">aquí.</router-link></span></p>
    </vx-card>

    <vx-card v-if="isMounted && !failed" class="mt-5">
        <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full">
                <vs-select
                  placeholder="Seleccione"
                  label="Proyecto"
                  class="w-full"
                  v-model="projectFilterSelected">
                  <vs-select-item :value="item.id" :text="item.alias" v-for="item in allData.projects" />
                </vs-select>
            </div>
            <div class="vx-col sm:w-1/5 w-full mb-4">
                <label class="vs-input--label">Fecha de inicio</label>
                <datepicker
                    placeholder="Fecha inicio"
                    :language="es"
                    v-model="startDate"
                    format="dd/MM/yyyy"
                    :disabledDates="disabledDates"
                    />
            </div>
            <div class="vx-col sm:w-1/5 w-full mb-4">
                <label class="vs-input--label">Fecha de término:</label>
                <datepicker
                    placeholder="Fecha final"
                    :language="es"
                    v-model="endDate"
                    format="dd/MM/yyyy"
                    :disabledDates="disabledDates"
                    />
            </div>
            <div class="vx-col sm:w-3/5 w-full mb-4 flex">
                <vs-button @click="datesChanged" color="primary" style="height: 40px" class="mt-6 mr-1 px-3">Consultar</vs-button>
                <vs-button
                  color="primary"
                  icon-pack="feather"
                  type="border"
                  class="px-3 mt-6 ml-4"
                  icon="icon-download"
                  style="height: 40px"
                  @click="downloadCSV">Descargar movimientos</vs-button>
            </div>
        </div>

        <vs-table class="text-center" :sst="true" @sort="handleSort" ref="table" stripe :max-items="30" :data="groupedMovements" noDataText="No hay datos disponibles">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <!-- ITEMS PER PAGE -->
                <div class="p-3 mb-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">Mostrando {{ from }} - {{ to }} de {{ totalRecords }}</span>
                </div>
            </div>

            <template slot="thead">
              <vs-th class="bold text-center" v-for="(col, idx) in columns" v-bind:key="idx">{{col.title}}</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                  <vs-td v-if="showAtLeastOneMulti && !tr.multiple"></vs-td>
                  <vs-td class="text-left">{{ dateTimeFormat(tr.created_at) }}</vs-td>
                  <vs-td class="text-left">
                    <div class="flex flex-wrap">
                      {{ tr.concept }}
                      <template v-if="tr.voucheable">
                        <vx-tooltip text="Descargar comprobante">
                          <feather-icon
                          class="ml-5"
                          icon="DownloadIcon"
                          svgClasses="h-5 w-5 stroke-current hover:text-primary cursor-pointer"
                          @click.stop="downloadVoucherRequest(tr)"/>
                        </vx-tooltip>
                      </template>
                    </div>
                  </vs-td>
                  <vs-td class="text-right"><strong>{{ costFormat(tr.income) }}</strong></vs-td>
                  <vs-td class="text-right"><strong>{{ costFormat(tr.outcome) }}</strong></vs-td>
                  <vs-td class="text-right"><strong>{{ costFormat(tr.final_balance) }}</strong></vs-td>

                <template v-if="tr.multiple" slot="expand">
                  <vs-table class="w-full text-center" :data="movements(tr.reference)" noDataText="No hay registros disponibles">
                    <template slot-scope="{data}">
                      <vs-tr class="bold" :key="indextr" v-for="(trx, indextr) in data">
                        <vs-td></vs-td>
                        <vs-td class="text-left">{{ dateTimeFormat(trx.created_at) }}</vs-td>
                        <vs-td class="text-left">{{ trx.concept }}</vs-td>
                        <vs-td></vs-td>
                        <vs-td class="text-right"><strong>{{ costFormat(trx.income) }}</strong></vs-td>
                        <vs-td class="text-right"><strong>{{ costFormat(trx.outcome) }}</strong></vs-td>
                        <vs-td class="text-right"><strong>{{ costFormat(trx.final_balance) }}</strong></vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </template>

              </vs-tr>
            </template>
        </vs-table>
        <br>
        <vs-pagination :total="totalPages" v-model="currentx"></vs-pagination>
        <!--div class="pager" v-if="allMovements.length > 0">
          <div class="flex flex-wrap">
              <vs-button radius @click="pager(allData.first_page_url)" class="mr-2 px-3"> << </vs-button>
              <vs-button radius @click="pager(allData.prev_page_url)" class="mr-2m px-3">{{"<"}}</vs-button>
              <vs-button radius class="mr-2 px-5">{{allData.current_page}}</vs-button>
              <vs-button radius @click="pager(allData.next_page_url)" class="mr-2 px-3">{{">"}}</vs-button>
              <vs-button radius @click="pager(allData.last_page_url)" class="mr-2 px-3">{{">>"}}</vs-button>
          </div>
        </div-->
    </vx-card>
  </div>
</template>

<script>
import formatHelper from '@mixins/formatHelper';
import dateHelper from '@mixins/dateHelper';
import Datepicker from 'vuejs-datepicker';
import { es } from "vuejs-datepicker/dist/locale";

const columnDefinitions = [
  { title: "FECHA", key: "date", sortable: true },
  { title: "CONCEPTO", key: "concept", sortable: true },
  { title: "INGRESO", key: "income", sortable: true },
  { title: "EGRESO", key: "outcome", sortable: true },
  { title: "SALDO", key: "balance", sortable: true }
];

export default {
  mixins: [formatHelper, dateHelper],
  components: {
      Datepicker
  },
  async mounted() {
    this.setInitialDates();
    await this.loadMovements(1);
  },
  data() {
    return {
      isFirstTime: true,
      es: es,
      allData:[],
      orderKey: "",
      startDate: null,
      endDate: null,
      columns: columnDefinitions,
      isMounted: false,
      loading: false,
      failed: false,
      disabledDates: {
        from: new Date()
      },
      currentx: 1,
      initialDateRange: 30,
      maxRangeDays: 90,
      isInvalidRange: false,
      rangeError: "El rango de tiempo máximo para consulta o descarga es de 3 meses.",
      groupedMovements: [],
      showAtLeastOneMulti: false,
      projectFilterSelected: 'all',
    };
  },
  computed: {
    allMovements(){
      return this.allData.data || [];
    },
    from(){
      return this.allData.from;
    },
    to(){
      return this.allData.to;
    },
    totalRecords(){
      return this.allData.total;
    },
    totalPages(){
      return Math.ceil(this.allData.total / this.allData.per_page);
    }
  },
  watch: {
    loading: function(){
      if(this.loading) {
        this.$vs.loading();
      }
      else {
        this.$vs.loading.close();
      }
    },
    currentx: async function (newv, oldv){
      await this.pager(newv);
    }
  },
  methods: {
    async goToStatementsPage(){
      await this.$router.push({name: 'estadosCuentaInversionista'});
    },
    setInitialDates(){
      let sdate = new Date();
      sdate.setDate(sdate.getDate() - this.initialDateRange);
      this.startDate = sdate;
      this.endDate = new Date();
    },
    async loadMovements(page){
      // se genera log de accion
      if (this.isFirstTime) {
        this.saveInvestorLogAction("LC11-24");
        this.isFirstTime = false;
      }
      this.isMounted = false;
      this.loading = true;
      this.failed = false;
      try {
        let data = {
          start: this.startDate,
          end: this.endDate,
          project_id: this.projectFilterSelected
        }
        let url = `/api/v2/investor/${this.InvestorId}/movementsList?page=${page}`;
        let response = await axios.post(url, data);
        this.allData = response.data;
        this.allData.projects.unshift({id: 'all', alias: 'Todos'});
        this.setMovementsType();
        this.groupMovements();
      } catch (e) {
        this.failed = true;
      }
      this.isMounted = true;
      this.loading = false;
    },
    async datesChanged() {
      const valid = this.validateDates();
      if(valid){
        await this.loadMovements(1);
        this.currentx = 1;
      }
    },
    async downloadVoucherRequest(tr){
      let url = `${this.ApiDomain}/api/v2/investor/operations/downloadVoucher/${tr.id}?access_token=${this.AccessToken}`;
      window.open(url, "_blank");
    },
    async viewVoucherRequest(tr){
      let url = `${this.ApiDomain}/api/v2/investor/operations/viewVoucher/${tr.id}?access_token=${this.AccessToken}`;
      window.open(url, "_blank");
    },
    async restoreRecords() {
        await this.loadMovements(1);
        this.currentx = 1;
    },
    handleSort(key, active) {
      console.log(`the user ordered: ${key} ${active}`)
    },
    async pager(page){
      await this.loadMovements(page);
    },
    async downloadCSV(){
      const valid = this.validateDates();
      if(!valid){
        return;
      }
      try {
        const startYear = this.startDate.getFullYear();
        const startMonth = this.startDate.getMonth() + 1;
        const startDay = this.startDate.getDate();
        const endYear = this.endDate.getFullYear();
        const endMonth = this.endDate.getMonth() + 1;
        const endDay = this.endDate.getDate();
        let params = `startYear=${startYear}&startMonth=${startMonth}&startDay=${startDay}&endYear=${endYear}&endMonth=${endMonth}&endDay=${endDay}&projectId=${this.projectFilterSelected}`;
        let url = `${this.ApiDomain}/api/v2/investor/${this.InvestorId}/movementsListCSV?access_token=${this.AccessToken}&${params}`;
        window.open(url, "_blank");
        // se genera log de accion
        this.saveInvestorLogAction("LC11-25");
      }
      catch (e) {
        this.warn(e)
      }
    },
    validateDates(){
      this.isInvalidRange = false;
      if(this.startDate > this.endDate){
        this.isInvalidRange = true;
        this.errorNotifDialog("Aviso", "La fecha de inicio no puede ser mayor a la fecha de término.")
        return false;
      }
      const diffTime = Math.abs(this.startDate - this.endDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if(diffDays > this.maxRangeDays){
        this.isInvalidRange = true;
        this.errorNotifDialog("Aviso", this.rangeError);
        return false;
      }
      return true;
    },
    movements(reference) {
      return this.allMovements
        .filter(mov => mov.reference === reference)
        .map(mov => mov);
    },
    movementsAmounts(reference) {
      let data = {
        count:0,
        incomes:0,
        outcomes:0,
        final_balance: 0
      };
      let finalBalanceSet = false;
      this.allMovements.filter(mov => mov.reference === reference).forEach(movement => {
        data.count +=1;
        if (movement.type === "deposit") {
          data.incomes += movement.amount;
        }else{
          data.outcomes += movement.amount;
        }
        if (!finalBalanceSet) {
          data.final_balance = movement.final_balance;
          finalBalanceSet = true;
        }
      });
      return data;
    },
    setMovementsType(){
      this.allMovements.forEach(movement => {
        let nn = movement.trx_type.substr(1, 1);
        movement.date = new Date(movement.created_at);
        if(nn !== "1"){
          movement.type = "charge";
          movement.outcome = movement.amount;
        }
        else {
          movement.type = "deposit";
          movement.income = movement.amount;
        }
      });
    },
    groupMovements(){
      this.showAtLeastOneMulti = false;
      this.groupedMovements = [];
      let groups = [];
      let group = {};
      this.allMovements.forEach(mov => {
        if (mov.reference === "" || mov.reference == null) {
          group = this.createGroup(false,mov.concept,null,mov.created_at,mov.income, mov.outcome,mov.final_balance,mov.id,mov.voucheable);
          groups.push(group);
        }
        else{
          if (groups.filter(g => g.reference === mov.reference).length === 0) {
            let dataGroup = this.movementsAmounts(mov.reference);
            let multi = dataGroup.count > 1;
            if (multi) {
              this.showAtLeastOneMulti = true;
              group = this.createGroup(multi,"Pago del proyecto "+this.getProjectAlias(mov.project_id)+" (ID: "+mov.project_id+")",mov.reference,mov.created_at,dataGroup.incomes,dataGroup.outcomes,dataGroup.final_balance,0,false);
            }else{
              let reference = mov.id;
              mov.reference = reference;
              group = this.createGroup(multi,mov.concept,reference,mov.created_at,mov.income,mov.outcome,mov.final_balance,mov.id,mov.voucheable);
            }
            groups.push(group);
          }
        }
        this.groupedMovements = groups;
      });
    },
    createGroup(multiple,concept,reference,created_at,income,outcome,final_balance,trxid,voucheable = false){
      return {
        multiple: multiple,
        concept: concept,
        reference: reference,
        created_at: created_at,
        income: income,
        outcome: outcome,
        final_balance: final_balance,
        id: trxid,
        voucheable: voucheable
      };
    },
    getProjectAlias(id){
      return this.allData.projects
        .filter(proj => proj.id === id)
        .map(proj => proj.alias);
    },
    downloadCSVLocal(){
      let array = [];
      array.push(['Fecha', 'Concepto', 'Referencia', 'Ingreso', 'Egreso', 'Saldo']);
      this.allMovements.forEach(f => {
        array.push([f.created_at, f.concept, f.reference, f.income, f.outcome, f.final_balance]);
      });

      let str = '';
      for (let i = 0; i < array.length; i++) {
        let line = '';
        line = array[i].join(",");
        str += line + '\r\n';
      }
      let blob = new Blob([str], { type: 'text/csv;charset=utf-8;' });

      let link = document.createElement('a');
      let url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'movimientos.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
};
</script>

